/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: qcwxqLdHUKR4

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicTextWithIcon.module.css"; // plasmic-import: qcwxqLdHUKR4/css

createPlasmicElementProxy;

export type PlasmicTextWithIcon__VariantMembers = {};
export type PlasmicTextWithIcon__VariantsArgs = {};
type VariantPropType = keyof PlasmicTextWithIcon__VariantsArgs;
export const PlasmicTextWithIcon__VariantProps = new Array<VariantPropType>();

export type PlasmicTextWithIcon__ArgsType = {
  icon?: React.ReactNode;
  title?: string;
  text?: string;
};
type ArgPropType = keyof PlasmicTextWithIcon__ArgsType;
export const PlasmicTextWithIcon__ArgProps = new Array<ArgPropType>(
  "icon",
  "title",
  "text"
);

export type PlasmicTextWithIcon__OverridesType = {
  textWithIcon?: Flex__<"div">;
  featureIcon?: Flex__<"div">;
  textContainer?: Flex__<"div">;
  heading?: Flex__<"h4">;
  text1?: Flex__<"p">;
};

export interface DefaultTextWithIconProps {
  icon?: React.ReactNode;
  title?: string;
  text?: string;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTextWithIcon__RenderFunc(props: {
  variants: PlasmicTextWithIcon__VariantsArgs;
  args: PlasmicTextWithIcon__ArgsType;
  overrides: PlasmicTextWithIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"textWithIcon"}
      data-plasmic-override={overrides.textWithIcon}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.textWithIcon
      )}
    >
      <div
        data-plasmic-name={"featureIcon"}
        data-plasmic-override={overrides.featureIcon}
        className={classNames(projectcss.all, sty.featureIcon)}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <PlasmicImg__
              alt={""}
              className={classNames(sty.img__h1Ewd)}
              displayHeight={"32px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"32px"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/94843607a305842b483d6723df760e1e.svg",
                fullWidth: 32,
                fullHeight: 32,
                aspectRatio: 1
              }}
            />
          ),

          value: args.icon
        })}
      </div>
      <div
        data-plasmic-name={"textContainer"}
        data-plasmic-override={overrides.textContainer}
        className={classNames(projectcss.all, sty.textContainer)}
      >
        <h4
          data-plasmic-name={"heading"}
          data-plasmic-override={overrides.heading}
          className={classNames(
            projectcss.all,
            projectcss.h4,
            projectcss.__wab_text,
            sty.heading
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.title;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </h4>
        <p
          data-plasmic-name={"text1"}
          data-plasmic-override={overrides.text1}
          className={classNames(
            projectcss.all,
            projectcss.p,
            projectcss.__wab_text,
            sty.text1
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.text;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </p>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  textWithIcon: [
    "textWithIcon",
    "featureIcon",
    "textContainer",
    "heading",
    "text1"
  ],
  featureIcon: ["featureIcon"],
  textContainer: ["textContainer", "heading", "text1"],
  heading: ["heading"],
  text1: ["text1"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  textWithIcon: "div";
  featureIcon: "div";
  textContainer: "div";
  heading: "h4";
  text1: "p";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTextWithIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTextWithIcon__VariantsArgs;
    args?: PlasmicTextWithIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTextWithIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicTextWithIcon__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTextWithIcon__ArgProps,
          internalVariantPropNames: PlasmicTextWithIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTextWithIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "textWithIcon") {
    func.displayName = "PlasmicTextWithIcon";
  } else {
    func.displayName = `PlasmicTextWithIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicTextWithIcon = Object.assign(
  // Top-level PlasmicTextWithIcon renders the root element
  makeNodeComponent("textWithIcon"),
  {
    // Helper components rendering sub-elements
    featureIcon: makeNodeComponent("featureIcon"),
    textContainer: makeNodeComponent("textContainer"),
    heading: makeNodeComponent("heading"),
    text1: makeNodeComponent("text1"),

    // Metadata about props expected for PlasmicTextWithIcon
    internalVariantProps: PlasmicTextWithIcon__VariantProps,
    internalArgProps: PlasmicTextWithIcon__ArgProps
  }
);

export default PlasmicTextWithIcon;
/* prettier-ignore-end */
